import type { ReactNode } from "react";
import { Chip } from "@mui/material";
import type { SxProps, Theme } from "@mui/material";

interface DesactiveChipProps {
  sx?: SxProps<Theme>;
}

function DesactiveChip({ sx }: Readonly<DesactiveChipProps>): ReactNode {
  return (
    <Chip
      label="désactivé"
      size="small"
      color="secondary"
      variant="filled"
      component="span"
      sx={{ fontSize: "0.75rem", ...sx }}
    />
  );
}

export default DesactiveChip;
